<template>
  <div>
    <template v-if="isIndex">
      <div id="majorCourse">
        <!-- title 标题, title 按钮 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <!-- 搜索框 -->
        <div class="searchCon">
          <div class="searchMain">
            <ots-refer :selectList="selectList" :request-form="requestForm" @search="searchList" />
          </div>
        </div>
        <!-- table 列表 -->
        <ots-table-group-new 
          :tableHeader="tableHeader" 
          :tableData="tableData" 
          :pagination="pagination"
          @changeNum="changeSize" 
          @changePage="changePage">
        </ots-table-group-new>
        <!-- 导入模板 -->
        <ots-custom-dialog :dialog.sync="importDialog" title="导入专业课程" width="40%">
          <template v-slot:content>
            <div class="exportDialog">
              <el-form ref="exportForm" :model="importForm">
                <el-form-item label="1.模板下载">
                  <span style="color:#006AFF;" @click="$getStaticFile('层次课程专业上传模板.xlsx')" class="cp">
                    <i class="el-icon-download"></i>
                    下载专业课程导入数据模板
                  </span>
                </el-form-item>
                <el-form-item label="3.选择文件" v-model="importForm.file">
                  <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
                </el-form-item>
              </el-form>
              <div class="impExplain">
                <span class="tipTitle"><i></i>提示：</span>
                <div>
                  <div>1：课程若多门，以英文逗号分隔。例：大学英语,计算机应用基础</div>
                  <div>2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；</div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="importDialog = false">取消</el-button>
            <el-button round type="primary" @click="rightImport">确定</el-button>
          </template>
        </ots-custom-dialog>
        <!-- 自定义字段未添加 层次 - 专业 弹窗 -->
        <el-dialog
          title="该功能不可用：请在自定义学生信息中，增加层次、专业字段！"
          :visible.sync="isShowView"
          width="480px"
          :show-close="false"
          :close-on-press-escape="false"
          :close-on-click-modal="false" >
          <span>是否前往：系统设置 - 自定义学生信息设置相关功能？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="backIndex(false)">取 消</el-button>
            <el-button type="primary" @click="backIndex(true)">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>
<script>
import { 
  getCourseListByLevelAndSubjectFN, 
  getSubjectListByLevelFN, 
  getLevelListByRelationFN,
  selectAllLSCByReq,  
  delLevelSubjectCourses, 
  importLevelSubjectCourseSet, 
  selectPlugs,
  exportLevelSubjectCourseByRequirementAPI
} from '@/http/modules/baseSet/majorCourse'

export default {
  data() {
    return {
      /* *** 导入模板显示开关 *** */
      importDialog: false,
      /* *** 文件数据 *** */
      importForm: {
        file: '',
      },
      /* *** title 按钮 *** */
      mainTopBtnList: [
        {
          title: '新增',
          fn: this.addSchoolDialog,
          plain: true,
        },
        {
          title: '导入',
          fn: this.importExcel
        },
        {
          title: "导出",
          fn: this.exportExcel
        }
      ],
      /* *** select 下拉数据 *** */
      selectList: [
        {
          title: "层次",
          type: "select",
          requestKey: "levelId",
          isSearch: true,
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '专业',
          type: 'select',
          requestKey: "subjectId",
          isSearch: true,
          label: 'name',
          value: 'id',
          data: []
        },
        {
          title: '课程',
          type: 'select',
          requestKey: 'courseId',
          isSearch: true,
          label: 'name',
          value: 'id',
          data: []
        }
      ],
      /* *** 层次, 专业, 课程 JSON */
      LscJson: [],
      /* *** 搜索表单参数(查询表格) *** */
      requestForm: {
        levelId: '',
        subjectId: '',
        courseId: '',
        size: 10,
        page: 1,
      },
      /* *** table 表格头配置 *** */
      tableHeader: [
        {
          title: "层次",
          prop: "levelName",
          fixed: "left",
        },
        {
          title: "专业",
          prop: "subjectName",
          fixed: "left",
        },
        {
          title: "课程",
          prop: "courseName",
          fixed: "left",
        },
        {
          title: "操作",
          type: "buttons",
          width: "120",
          fixed: "right",
          align: "right",
          headerAlign: "right",
          btnList: [
            {
              title: "删除",
              formatter: (scope) => {
                if (scope.row.state == 1) {
                  return true;
                } else {
                  return false;
                }
              },
              click: this.deleteLsc,
            },
          ],
        },
      ],
      /* *** table 表格数据 *** */
      tableData: [],
      /* *** 分页--总条数 *** */
      pagination: {
        total: 0,
      },
      /* *** 页面是否可用 *** */
      isShowView : false,
    }
  },
  computed: {
    /* ***  是否是主页面 *** */
    isIndex() {
      return this.$route.name == 'majorCourse';
    },
  },
  watch: {
    /* *** 三级联动, 课程变化不影响其它, 不使用深度监听 *** */
    /* *** 层次改变, 查询专业 *** */
    'requestForm.levelId': function () {
      /* *** 层次改变(非全部), 重置专业和课程 *** */
      this.initLscData('resetSubjectAndCourse');
      this.getSubject();
    },
    
    /* *** 专业改变, 查询课程 *** */
    'requestForm.subjectId': function () {
      /* *** 专业改变(非全部), 重置课程 *** */
      this.initLscData('resetCourse');
      this.getCourseList();
    },

    /* *** 进入页面重新查询数据 *** */
    $route: {
      handler: function () {
        if (this.$route.name == 'majorCourse') {
          /* ** 重置表单数据, 查询 ** */
          this.resetSearch(true);
        }
      },
      immediate: true,
    },

  },
  created() {
    /* ** 层次-专业 - 自定义字段中 - 是否配置 ** */
    this.isPlugs();
  },
  mounted() {
    this.getLevel();
    this.getSubject();
    this.getCourseList();
  },
  methods: {
    async exportExcel() {
      let { levelId, subjectId, courseId } = this.requestForm;
      let params = {
        levelId,
        subjectId,
        courseId
      }
      const { data, code } = await exportLevelSubjectCourseByRequirementAPI(params);
      if (code) {
        window.open(data);
      }
    },

    initLscData(reset) {
      if (reset == 'resetSubjectAndCourse' && this.requestForm.levelId) {
        this.requestForm.subjectId = '';
      } else if (reset == 'resetCourse' && this.requestForm.subjectId) {
        this.requestForm.courseId = '';
      }
    },

    // 层次
    getLevel(){
      getLevelListByRelationFN().then(res=>{
        if (res.code == 1) {
          this.selectList[0].data = [{ id: "", name: "全部" }, ...res.data]
        }
      })
    },

    // 专业
    getSubject() {
      getSubjectListByLevelFN({levelId: this.requestForm.levelId}).then(res=>{
        if (res.code == 1) {
          this.selectList[1].data = [{ id: "", name: "全部" }, ...res.data]
        }        
      })
    },

    // 课程
    getCourseList() {
      let params = {
        levelId: this.requestForm.levelId,
        subjectId: this.requestForm.subjectId
      }
      getCourseListByLevelAndSubjectFN(params).then(res=>{
        if (res.code == 1) {
          this.selectList[2].data = [{ id: "", name: "全部" }, ...res.data]
        }
      })
    },

    /*************************
     * @this 层次专业是否配置
     *************************/
    isPlugs(){
      let params = {levelType: 'level', subjectType: 'subject'}
      selectPlugs(params).then( res => {
        if (res.code == 1) {
          this.isShowView = res.data == 'false'
        }
      });
    },

    /******************************
     * @this 层次专业未开启,跳转路径
     ******************************/
    backIndex(val){
      if (val) {
        // 跳转自定义配置
        this.$router.push('/sys/customForm')
      } else {
        // 跳转主页
        this.$router.push('/index')
      }
    },

    /*************************
     * @this 新增按钮
     ************************/
    addSchoolDialog() {
      this.$router.push({ name: 'addMajorCourse' })
    },

    /*************************
     * @this 导入按钮
     ************************/
    importExcel() {
      this.importDialog = true
    },

    /*************************
     * @this 执行导入
     ************************/
    async rightImport() {
      // 1. 导入时, 文件必传
      if (!this.importForm.file) {
        this.$message.error('请选择文件')
        return
      }
      // 2. 配置导入文件, 参数
      const fd = new FormData()
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item])
      }
      // 3. 执行导入
      const { code, data } = await importLevelSubjectCourseSet(fd)
      // 4. 导入结果进行提示
      if (code == 1) {
          // 5. 失败数量
          const failNum = data.errorCount ? parseInt(data.errorCount) : 0
          // 6. 总数
          const totalNum = parseInt(data.allCount)
          // 7. 成功数量
          const successNum = totalNum - failNum
          // 8. 轻提示
          let message = `导入完成，成功导入${successNum}，失败条数${failNum}`
          // 9. 关闭导入弹窗
          this.importDialog = false
          // 10. confirm 展示导入结果
          this.$confirm(message, '导入结果', {
            confirmButtonText: failNum > 0 ? '查看错误记录' :'确定',
            cancelButtonText: '取消',
            type: failNum > 0 ? 'warning' :'success'
          }).then(async () => {
            if (failNum > 0) {
              window.location.href = data.address
            }
          })
          // 重新搜索
          this.search();
      }
    },

    /*************************
     * @this 导入文件处理
     ************************/
    handleFormData(val) {
      this.importForm.file = val.file
    },

    /***************************
     * @this 数组对象去重(根据id)
     ***************************/
    // newLscList(arr) {
    //   let map = new Map()
    //   for (let item of arr) {
    //     if (!map.has(item.id)) {
    //       map.set(item.id, item)
    //     }
    //   }
    //   return [...map.values()]
    // },

    /************************************
     * @this 查询所有层次_专业_课程_json
     * - 只执行一次, 配置数据
     ************************************/
    // getLSC() {
    //   getLSCRelation().then(res => {
    //     this.LscJson = res.data
    //     this.initData()
    //   })
    // },

    /***********************************
     * @initData
     * -  配置_select_下拉数据(所有)
     * - 切换层次(切换结果非全部), 专业/课程 重置为全部
     * - 切换专业(切换结果非全部), 课程 重置为全部
     ***********************************/
    // initData(reset) {
    //   // 1. 切换 层次/专业
    //   if (reset == 'resetSubjectAndCourse' && this.requestForm.levelId) {
    //     this.requestForm.subjectId = '';
    //     this.requestForm.courseId = '';
    //   } else if (reset == 'resetCourse' && this.requestForm.subjectId) {
    //     this.requestForm.courseId = '';
    //   }

    //   // (1) 重置专业, 课程下拉数据
    //   this.selectList[0].data = [{ id: '', name: '全部' }];
    //   this.selectList[1].data = [{ id: '', name: '全部' }];
    //   this.selectList[2].data = [{ id: '', name: '全部' }];

    //   // (2) 根据 requestForm 配置所有的基础数据;
    //   this.LscJson.map(e => {
    //     /* *** 配置层次, 数据固定 *** */
    //     this.selectList[0].data.push(
    //       { id: e.levelId, name: e.levelName }
    //     )

    //     // (3) 选择了层次, 非 '全部'
    //     if (e.levelId == this.requestForm.levelId && this.requestForm.levelId) {
    //       /* *** 专业 (非全部) *** */
    //       e.subjectVoList.map(sub => {
    //         this.selectList[1].data.push({ id: sub.subjectId, name: sub.subjectName });

    //         // (5) 选择了专业, 非 '全部'
    //         if (sub.subjectId == this.requestForm.subjectId && this.requestForm.subjectId) {
    //           /* *** 课程 (非全部, 非全部) *** */
    //           sub.courseVoList.map(cou => {
    //             this.selectList[2].data.push({ id: cou.courseId, name: cou.courseName });
    //           })

    //           // (6) 选择专业为'全部' 
    //         } else if (!this.requestForm.subjectId) {
    //           /* *** 课程 (非全部 - 全部) *** */
    //           sub.courseVoList.map(cou => {
    //             this.selectList[2].data.push({ id: cou.courseId, name: cou.courseName });
    //           })
    //         }
    //       })

    //       // (4) 选择了层次为 '全部'
    //     } else if (!this.requestForm.levelId) {
    //       /* *** 专业 (全部) *** */
    //       e.subjectVoList.map(sub => {
    //         this.selectList[1].data.push({ id: sub.subjectId, name: sub.subjectName });

    //         // (7) 选择了专业, 非 '全部'
    //         if (sub.subjectId == this.requestForm.subjectId && this.requestForm.subjectId) {
    //           /* *** 课程 (全部 - 非全部) *** */
    //           sub.courseVoList.map(cou => {
    //             this.selectList[2].data.push({ id: cou.courseId, name: cou.courseName });
    //           })

    //           // (8) 选择专业为'全部'
    //         } else if (!this.requestForm.subjectId) {
    //           /* *** 课程 (全部 - 全部) *** */
    //           sub.courseVoList.map(cou => {
    //             this.selectList[2].data.push({ id: cou.courseId, name: cou.courseName });
    //           })
    //         }
    //       })
    //     }
    //   })

    //   // 2. 专业, 课程去重, 避免相同下拉项
    //   this.selectList[1].data = [...this.newLscList(this.selectList[1].data)];
    //   this.selectList[2].data = [...this.newLscList(this.selectList[2].data)];
    // },

    /**************************
     * @resetSearch 重置表单数据查询
     **************************/
    resetSearch(isSetPage){
      this.requestForm.levelId = ""
      this.requestForm.subjectId = ""
      this.requestForm.courseId = ""
      if (isSetPage) {
        this.requestForm.page = 1
      }
      /* ** 查询表单数据 ** */
      this.search()
    },

    /*************************
     * @this 表单按钮
     ************************/
    searchList() {
      this.requestForm.page = 1
      this.search()
    },

    /*************************
     * @search 搜索table列表数据
     ************************/
    search() {
      let params = { ...this.requestForm }
      selectAllLSCByReq(params).then(res => {
        if (res.code == 1) {
          this.tableData = res.data.records
          this.pagination.total = res.data.total
        }
      })
    },

    /*************************
     * @deleLsc 删除列表数据
     ************************/
    deleteLsc(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {levelId: row.levelId, subjectId: row.subjectId}
        delLevelSubjectCourses(params).then(res => {
          if (res.code == 1) {
            // this.getLSC()
            /* ** 重新配置下拉列表, 搜索 ** */
            this.$message.success('操作成功！')
            this.resetSearch(false)
          }
        })
        this.search();
      });
    },

    /*************************
     * @changeSize 分页相关
     ************************/
    changeSize(num) {
      this.requestForm.size = num
      this.search()
    },

    /*************************
     * @changePage 分页相关
     ************************/
    changePage(p) {
      this.requestForm.page = p
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
.searchCon {
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  .searchMain {
    flex: 1;
  }
  .searchBtn {
    flex-shrink: 0;
    width: 72px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.dialog-footer /deep/ .el-button--default:hover {
  background: #ecf5ff;
  color: #176de6;
  border-color: #176de6 !important;
}
/deep/ .el-dialog{
  border-radius: 8px;
}
/deep/ .el-dialog__title {
  font-weight: 700;
}
/deep/ .el-dialog__body {
  padding: 32px;
}
/deep/ .el-dialog.auto-scroll .el-dialog__footer {
  padding-top: 0;
}
/deep/ .el-dialog .el-input {
  height: 36px;
  line-height: 36px;
}
/deep/ .el-dialog .el-input__inner,
/deep/ .el-dialog .el-input__icon {
  height: 36px;
  line-height: 36px;
}
/deep/ .el-dialog .el-form-item__content {
  line-height: 1;
}
/deep/ .el-dialog .default-upload-container {
  width: 240px;
  height: 36px;
  line-height: 36px;
}
/deep/ .el-form-item__label {
  line-height: 1;
  padding-bottom: 16px;
}

/deep/ .el-dialog .el-pagination__sizes .el-input {
  width: 100px;
}
/deep/ .el-dialog .el-pagination__editor.el-input {
  width: 50px;
}
/deep/ .el-dialog .el-pagination__sizes .el-input__inner,
/deep/ .el-dialog .el-pagination__sizes .el-input__icon,
/deep/ .el-dialog .el-pagination__jump .el-input__inner {
  height: 28px;
  line-height: 28px;
}
/deep/ .el-radio-button__inner {
  margin-right: 16px;
  color: #45494d !important;
  background: #f4f5f8 !important;
  font-size: 13px;
  border-radius: 4px !important;
  border: 1px solid #dadde6 !important;
  padding: 10px 20px;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #ebf5ff !important;
  border: 1px solid #006aff !important;
  color: #006aff !important;
  box-shadow: none;
}
.dialog-footer /deep/ .el-button {
  width: auto;
  height: 30px;
  border-radius: 15px;
  padding: 0 23px;
  box-sizing: border-box;
}
/deep/ .el-form-item__label {
  float: none !important;
  display: block;
  text-align: left;
  padding-bottom: 8px !important;
}
/deep/ .el-dialog.is-fullscreen {
  background: #f4f5f8;
  margin-top: 60px;
  margin-bottom: 0;
  height: calc(100% - 60px);
  .el-dialog__header {
    background: #fff;
    height: 64px;
    box-sizing: border-box;
    box-shadow: 0px -1px 0px 0px #f1f2f5;
    border-radius: 8 px 8 px 0 px 0 px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    .el-dialog__headerbtn{
      top: 23px;
    }
  }
}
/deep/ .el-dialog.is-fullscreen .el-dialog__body {
  padding-top: 0 !important;
}
</style>